import apiClient from './api_client_requests';

export default config => {
    return async payload => {
        await apiClient(config).apiMethod({
            method: 'PlayerLogout',
            args: {
                logout: 1,
            },
        });

        return {
            loggedIn: false,
        };
    };
};
